import React from 'react';
import { Header } from '@spark';

const DatasetsHeader = () => (
    <div className="fs-unmask" style={{ padding: '24px 0 32px 0' }}>
        <Header
            showBreadcrumb={false}
            showBackButton={false}
            showActionBar={false}
            title="All Datasets"
            subtitle="Create and manage your datasets"
        />
    </div>
);

export default DatasetsHeader;
